import { BinIcon } from "../../../../components/icon/Icon";
import { Button } from "react-bootstrap";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";
import {
    WithdrawalRequestSentButtonsContainerStyled,
    WithdrawalRequestSentIconWrapperStyled,
    WithdrawalRequestSentStyled
} from "./styled/WithdrawalRequestSentStyled";

function WithdrawalRequestSent(props) {
    const {className, onContinueTradingClick, onHistoryClick} = props;
    const {getLangPath} = useLangContext();

    return <WithdrawalRequestSentStyled className={className}>
        <center>
            <WithdrawalRequestSentIconWrapperStyled>
                <BinIcon name={'IcBankCardArrowRight'}/>
            </WithdrawalRequestSentIconWrapperStyled>
            <h4>{getLangPath('withdrawal.request_sent_title')}</h4>
            <p className={'content'}>{getLangPath('withdrawal.request_sent_funds')}</p>
            <p className={'description'}>{getLangPath('withdrawal.request_sent_support')}</p>
            <WithdrawalRequestSentButtonsContainerStyled>
                <Button size={'lg'} onClick={onContinueTradingClick}>
                    {getLangPath('error.request_button')}
                </Button>
                <Button size={'lg'} variant={'outline'} onClick={onHistoryClick}>
                    {getLangPath('transaction_history.history')}
                </Button>
            </WithdrawalRequestSentButtonsContainerStyled>
        </center>
    </WithdrawalRequestSentStyled>
}

export default WithdrawalRequestSent;
